import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_1211 implements Validator {

	public static id = 'CTRL_1211';
	private message = 'error.ctr_1211';


	public LOG: LogService = new LogService(CTRL_1211);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1211.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const nameWithStepId = map.get(ctrl.value.rgCtrls.name);
    const  nameCtrl = form.controls[nameWithStepId];
				if (nameCtrl.value === '') {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}

	calculateDiffDate(dateSent){
		const currentDate = new Date();
		dateSent = new Date(dateSent);
		return  Math.floor((currentDate.getTime() - dateSent.getTime()) / 1000 / 60 / 60 / 24);
	}
}
